<script>
import NotificationModal from '@/components/organism/restaurants/NotificationModal.vue'

export default {
    name: 'NotificationAllowButton',
    components: { NotificationModal },
    data() {
        return {
            buttonNeeded: false,
        }
    },
    computed: {
        isDefault() {
            return (
                Notification.permission === 'default' &&
                this.$user.model.notification_settings.delivery_push
            )
        },
    },
    mounted() {
        this.statusChanged()
        if (this.isDefault) {
            this.showNotificationModal()
        }
    },
    methods: {
        showNotificationModal() {
            this.$refs.notificationModal.openModal()
        },
        statusChanged() {
            this.buttonNeeded =
                Notification.permission === 'granted' &&
                this.$user.model.notification_settings.delivery_push
        },
    },
}
</script>

<template lang="pug">
div
    notification-modal(ref="notificationModal" @changed="statusChanged")
    .btn.btn-secondary.btn-block(v-if="!buttonNeeded" @click="showNotificationModal")
        icon.mr-4(icon="fa-solid fa-bell" )
        span {{ $t('order.turn_on_push_notifications') }}
</template>
